import { FunctionComponent } from "react";
import HeaderBG from '../../../../../assets/header-bg.png';


const HeroImage: FunctionComponent = () => (
  <div>
    <img
      src={HeaderBG}
      height={500}
      className="w-full lg:w-[750px] lg:absolute lg:landing-header-clip right-0 top-0 z-20"
      alt="Financial success visualization"
    />
  </div>
);


export default HeroImage;


